import CustomStatus from '../../CustomViews/Elements/CustomStatus';
import { ActiveStatus, ActiveStatusEnum, BillingStatus, BillingStatusEnum, LicenseStatus, LicenseStatusEnum } from "../Enums/StatusEnums";

const StatusHelper = {
    getLicenseStatus: function (status: LicenseStatusEnum) {
        return <CustomStatus colorType={LicenseStatus[status]?.color} label={LicenseStatus[status]?.title} />;
    },
    getAdminUserStatus: function (status: ActiveStatusEnum) {
        return <CustomStatus colorType={ActiveStatus[status]?.color} label={ActiveStatus[status]?.title} />;
    },
    getBillingStatus: function (status: BillingStatusEnum) {
        return <CustomStatus colorType={BillingStatus[status]?.color} label={BillingStatus[status]?.title} />;
    },
}

export default StatusHelper;